<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light v-if="dialog">
            <v-alert color="error" icon="warning" v-if="error" value="true">
                {{ error }}
            </v-alert>
        <v-card-title class="headline grey--text">
            Agregar sanción
        </v-card-title>
        <v-card-text class="pt-0">
            <v-container fluid grid-list-xs>
                <v-layout row wrap ref="form">
                    <v-flex xs12 sm6>
                        <v-text-field
                                slot="activator"
                                label="Nombre"
                                v-model="data.name"
                                light
                                color="green"
                                :rules="rules.required"
                                ref="name"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                            <v-text-field
                                slot="activator"
                                label="Número"
                                v-model="data.number_player"
                                light
                                color="green"
                                :rules="rules.required"
                                ref="number_player"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                                slot="activator"
                                label="Equipo"
                                v-model="data.team"
                                light
                                color="green"
                                ref="team"
                                :rules="rules.required"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                            <v-text-field
                                slot="activator"
                                label="Categoría"
                                v-model="data.category"
                                light
                                color="green"
                                ref="category"
                                :rules="rules.required"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            label="Causal"
                            v-model="data.causal"
                            light
                            type="text"
                            color="green"
                            :rules="rules.required"
                            ref="causal"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            label="Sanción"
                            v-model="data.sanction"
                            light
                            type="text"
                            color="green"
                            :rules="rules.required"
                            ref="sanction"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="cancel()">No</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Sanction from '@/models/sanction'
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
    name: 'NewSanctionModal',
    props: {
        dialog: { required: true, default: false }
    },
    data() {
        return {
            tryToSave:false,
            error:null,
            hasErrors: false,
            data: {
                name: '',
                number_player: '',
                team: '',
                category: '',
                causal: '',
                sanction: ''
            },
            rules: {
                required: [
                    val => {
                        let res = ((String(val) || '').length > 0 && val != null) || 'Este campo es obligatorio'
                        return res
                    }
                ]
            }
        }
    },
    watch: {
        sanction(val) {
          if(!val){return}
          this.error = null
          this.tryToSave = false
          this.data.name = val.name
          this.data.number_player = val.number_player
          this.data.team = val.team
          this.data.category = val.category
          this.data.causal = val.causal
          this.data.sanction = val.sanction
        }
    },
    computed: {
      ...mapGetters([
        
      ]),
        form() {
            return {
                name: this.data.name,
                number_player: this.data.number_player,
                team: this.data.team,
                category: this.data.category,
                causal: this.data.causal,
                sanction: this.data.sanction
            }
        }
    },
    methods: {
        ...mapActions([

        ]),
        confirm(btnPressed) {
            this.tryToSave = true
            this.hasErrors = false
            Object.keys(this.form).forEach(f => {
                if(!this.form[f])
                     this.hasErrors = true

                this.$refs[f].validate(true)
            })

            if(this.hasErrors) return

            var sanction = new Sanction()
            sanction.name = this.data.name
            sanction.number_player = this.data.number_player
            sanction.team = this.data.team
            sanction.category = this.data.category
            sanction.causal = this.data.causal
            sanction.sanction = this.data.sanction

            this.error = ""
            this.$emit('response', sanction)

            this.clearFields();
        },
        cancel() {
            this.error = ""
            this.$emit('cancel', 'newsanctionmodal')
            this.clearFields();
        },
        clearFields() {
            this.data.name = ''
            this.data.number_player = ''
            this.data.team = ''
            this.data.category = ''
            this.data.causal = ''
            this.data.sanction = ''
        }
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/sanctions/NewSanctionModal.vue